var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.969,
    height: 23.969,
    viewBox: "0 0 23.969 23.969"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "linkedin-logo_svg__aa",
    d: "M21.572 0H2.4A2.4 2.4 0 000 2.4v19.172a2.4 2.4 0 002.4 2.4h19.172a2.4 2.4 0 002.4-2.4V2.4a2.4 2.4 0 00-2.4-2.4zM7.191 20.373H3.6V9.587h3.6zM5.393 7.55A2.157 2.157 0 117.55 5.393 2.148 2.148 0 015.393 7.55zm14.98 12.823h-3.6v-6.351a1.8 1.8 0 00-3.6 0v6.352h-3.6V9.587h3.6v1.438a3.871 3.871 0 013-1.678 4.246 4.246 0 014.195 4.195z"
  })));
}

export default SvgLinkedinLogo;